/**
 * @generated SignedSource<<d251a5f432ddffea4f8c3a83610b160d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type videoSeoVideo$data = {
  readonly descriptionBody: {
    readonly text: string | null | undefined;
  } | null | undefined;
  readonly headline: string | null | undefined;
  readonly image: {
    readonly style: {
      readonly url: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly subHeadline: {
    readonly text: string | null | undefined;
  } | null | undefined;
  readonly summary: {
    readonly text: string | null | undefined;
  } | null | undefined;
  readonly urlAlias: string;
  readonly " $fragmentType": "videoSeoVideo";
};
export type videoSeoVideo$key = {
  readonly " $data"?: videoSeoVideo$data;
  readonly " $fragmentSpreads": FragmentRefs<"videoSeoVideo">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "videoSeoVideo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    },
    {
      "alias": "descriptionBody",
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "body",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "subHeadline",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "summary",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "type": "MAIN_IMAGE"
          }
        }
      ],
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "wide_landscape"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": "style(filter:{\"style\":\"wide_landscape\"})"
        }
      ],
      "storageKey": "image(filter:{\"type\":\"MAIN_IMAGE\"})"
    }
  ],
  "type": "Video",
  "abstractKey": null
};
})();

(node as any).hash = "764a186dab63b714bde5830d6123bbca";

export default node;
